"use strict";

import gsap from "gsap";
import barba from "@barba/core";


(function() {
	if (history.scrollRestoration) {
		history.scrollRestoration = 'manual';
	}
	
	
	barba.init({
		//debug: true,
		
		prevent: (/*{ el }*/) => false,
		
		
		transitions: [{
			name: 'fade',
			leave: (data) => {
				return gsap.to(data.current.container, {
					opacity: 0,
					duration: .5,
					y:-100,
					ease:'power3.in',
				});
			},
			enter: (data) => {	
				gsap.from(data.next.container, {
					opacity: 0,
					y: 100,
					duration: 1,
					ease:'power3.out',
				});
			},
		}],
		
		views: [{
			namespace: 'main',
			beforeEnter() {
				window.scrollTo(0,0);
			},
			
			afterEnter(/* data */) {
			
			},
		}],
	});
	
	
	barba.hooks.before(() => {
		const evt = new CustomEvent('pageLeave', {
			detail:{ document: document }, 
		});
		document.dispatchEvent(evt);
	});
	
	
	barba.hooks.after(() => {
		const evt = new CustomEvent('pageLoad', {
			detail:{ document: document }, 
		});
		document.dispatchEvent(evt);
	});
	
})();


const evt = new CustomEvent('pageLoad', { 
	detail:{ document: document }, 
});
document.dispatchEvent(evt);